const SeasonalHotspotsData = [
    {
      "city": "Miami",
      "peakHolidayMonth": 800,
      "residents": 160,
      "country": "USA"
    },
    {
      "city": "The Hamptons",
      "peakHolidayMonth": 700,
      "residents": 25,
      "country": "USA"
    },
    {
      "city": "West Palm Beach",
      "peakHolidayMonth": 400,
      "residents": 64,
      "country": "USA"
    },
    {
      "city": "Paris",
      "peakHolidayMonth": 300,
      "residents": 126,
      "country": "France"
    },
    {
      "city": "Nice",
      "peakHolidayMonth": 200,
      "residents": 60,
      "country": "France"
    },
    {
      "city": "Golden Triangle, Algarve",
      "peakHolidayMonth": 200,
      "residents": 20,
      "country": "Portugal"
    },
    {
      "city": "Napa",
      "peakHolidayMonth": 200,
      "residents": 28,
      "country": "USA"
    },
    {
      "city": "Aspen",
      "peakHolidayMonth": 200,
      "residents": 6,
      "country": "USA"
    },
    {
      "city": "Santa Barbara & Montecito",
      "peakHolidayMonth": 200,
      "residents": 82,
      "country": "USA"
    },
    {
      "city": "San Diego",
      "peakHolidayMonth": 200,
      "residents": 70,
      "country": "USA"
    },
    {
      "city": "Jackson Hole",
      "peakHolidayMonth": 150,
      "residents": 10,
      "country": "USA"
    },
    {
      "city": "Carmel-by-the-Sea",
      "peakHolidayMonth": 150,
      "residents": 40,
      "country": "USA"
    },
    {
      "city": "Boca Raton",
      "peakHolidayMonth": 150,
      "residents": 38,
      "country": "USA"
    },
    {
      "city": "Cannes",
      "peakHolidayMonth": 150,
      "residents": 20,
      "country": "France"
    },
    {
      "city": "Antibes",
      "peakHolidayMonth": 150,
      "residents": 18,
      "country": "France"
    },
    {
      "city": "Lisbon",
      "peakHolidayMonth": 150,
      "residents": 35,
      "country": "Portugal"
    },
    {
      "city": "Lugano",
      "peakHolidayMonth": 150,
      "residents": 30,
      "country": "Switzerland"
    },
    {
      "city": "Lake Como",
      "peakHolidayMonth": 100,
      "residents": 15,
      "country": "Italy"
    },
    {
      "city": "Saint Jean Cap Ferrat",
      "peakHolidayMonth": 100,
      "residents": 12,
      "country": "France"
    },
    {
      "city": "Saint Tropez",
      "peakHolidayMonth": 100,
      "residents": 11,
      "country": "France"
    },
    {
      "city": "Villefranche-sur-Mer",
      "peakHolidayMonth": 100,
      "residents": 14,
      "country": "France"
    },
    {
      "city": "Sanremo",
      "peakHolidayMonth": 100,
      "residents": 8,
      "country": "Italy"
    },
    {
      "city": "Porto Cervo",
      "peakHolidayMonth": 100,
      "residents": 6,
      "country": "Italy"
    },
    {
      "city": "Cape Town",
      "peakHolidayMonth": 100,
      "residents": 26,
      "country": "South Africa"
    },
    {
      "city": "Vail",
      "peakHolidayMonth": 100,
      "residents": 3,
      "country": "USA"
    },
    {
      "city": "Naples",
      "peakHolidayMonth": 100,
      "residents": 24,
      "country": "USA"
    },
    {
      "city": "Park City",
      "peakHolidayMonth": 100,
      "residents": 8,
      "country": "USA"
    }
];

export {SeasonalHotspotsData};